import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  // filter,
  // includes,
  lensProp,
  map,
  prop,
  set,
  sortBy,
} from "ramda";
import { getProjectId, getProjectLanguages } from "../common/selectors";
import { useSelector } from "react-redux";
import { notBlank } from "../common/general";

const defaultLangs = [
  { code: "eng", name: "English", order: 0, translation: "" },
  { code: "fre", name: "French", order: 1, translation: "" },
  { code: "ita", name: "Italian", order: 2, translation: "" },
  { code: "ger", name: "German", order: 3, translation: "" },
  { code: "spa", name: "Spanish", order: 4, translation: "" },
  { code: "arm", name: "Armenian", order: 5, translation: "" },
  { code: "chi", name: "Chinese", order: 6, translation: "" },
  { code: "kor", name: "Korean", order: 7, translation: "" },
  { code: "ara", name: "Arabic", order: 8, translation: "" },
];

// Add new languages to translation files
export const useLanguages = () => {
  const { t } = useTranslation();
  const projectId = useSelector(getProjectId);
  const projectLanguages = useSelector(getProjectLanguages);
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    const languages = notBlank(projectLanguages)
      ? projectLanguages
      : defaultLangs;
    const options = map(
      lang =>
        set(
          lensProp("translation"),
          t(`file_details.languages.${lang.code}`, lang.name),
          lang
        ),
      languages
    );

    setLanguages(sortBy(prop("order"), options));
  }, [t, projectId, projectLanguages]);

  return languages;
};
